export function isObjectEmpty<T extends object>(obj: T): boolean {
  return Object.keys(obj).every((objKey) => obj[objKey as keyof T] === null || obj[objKey as keyof T] === undefined);
}
